import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import authReducer, { initialState as authState } from './auth/reducers';
import ordersReducer, { initialState as ordersState } from './orders/reducers';
import commentsReducer, {
  initialState as commentsState,
} from './comments/reducers';
import mapReducer, { initialState as mapState } from './map/reducers';
import basicOrderReducer, {
  initialState as basicOrderState,
} from './basicOrder/reducers';
import tagsReducer, { initialState as tagsState } from './tags/reducers';
import handoverReducer, {
  initialState as handoverState,
} from './handover/reducers';
import hwoReducer, { initialState as hwoState } from './hwo/reducers';
import helpReducer, { initialState as helpState } from './helpDesk/reducers';

export const initializeState = () => {
  return {
    authState,
    ordersState,
    commentsState,
    mapState,
    basicOrderState,
    tagsState,
    handoverState,
    hwoState,
    helpState,
  };
};

export default combineReducers({
  authState: authReducer,
  ordersState: ordersReducer,
  commentsState: commentsReducer,
  mapState: mapReducer,
  basicOrderState: basicOrderReducer,
  tagsState: tagsReducer,
  handoverState: handoverReducer,
  hwoState: hwoReducer,
  router: routerReducer,
  helpState: helpReducer,
});
